
export const DASHBOARD = '/dashboard';
export const SUBSCRIPTIONS = '/subscriptions';
